'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*eslint-disable */
var QuestionMark = function QuestionMark(props) {
  return _react2.default.createElement(
    _Icon2.default,
    _extends({ viewBox: '0 0 10 18' }, props),
    _react2.default.createElement(
      'g',
      null,
      _react2.default.createElement('path', { d: 'M3.524 13.279c0-1.037.172-1.977.512-2.806.339-.829.902-1.623 1.676-2.362 1.132-1.083 1.426-1.494 1.55-1.709a2.62 2.62 0 0 0 .325-1.307c0-.688-.273-1.3-.789-1.767-.494-.45-1.15-.679-1.948-.679-.822 0-1.513.275-2.053.816a2.841 2.841 0 0 0-.799 1.59H0c.088-1.196.523-2.182 1.322-3C2.235 1.117 3.467.642 4.984.642c.98 0 1.82.197 2.493.582.663.381 1.202.94 1.603 1.66.4.718.602 1.483.602 2.271 0 .425-.064.852-.19 1.268a5.631 5.631 0 0 1-.619 1.315c-.109.173-.41.551-1.229 1.367-.924.916-1.193 1.284-1.314 1.481-.196.317-.356.72-.488 1.231-.098.386-.166.867-.205 1.461H3.524zm2.291 3.082c0 .756-.561 1.37-1.253 1.37-.692 0-1.253-.614-1.253-1.37 0-.756.56-1.368 1.253-1.368.692 0 1.253.612 1.253 1.368',
        fillRule: 'evenodd' })
    )
  );
};
/*eslint-enable */

exports.default = QuestionMark;
//# sourceMappingURL=QuestionMark.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/src/Icons/dist/components/QuestionMark.js